import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useZipCodeService } from '@app/hooks';
import FormField from '../FormField';
import { isEmpty } from '@app/utils/index';

const ZipCodeField = ({ isZipCodeRequired, autoCompleteOnZipCode }) => {
  const [t] = useTranslation();
  const { setValue, getValues, trigger } = useFormContext();

  const { getCityState } = useZipCodeService();

  const onBlurZipCode = useCallback(
    async e => {
      const zipCode = e.target.value;
      if (autoCompleteOnZipCode && !isEmpty(zipCode)) {
        const country = getValues('country');
        const { city, state } = await getCityState({
          countryName: country,
          zipCode: zipCode
        });
        if (!isEmpty(city)) {
          setValue('city', city);
          trigger('city');
        }
        if (!isEmpty(state)) {
          setValue('state', state);
          trigger('state');
        }
      }
    },
    [autoCompleteOnZipCode, getCityState, getValues, setValue]
  );

  return (
    <FormField
      fieldId="zipCode"
      required={isZipCodeRequired}
      label={t('CAT_EMAIL_ZIP')}
      maxLength="10"
      onBlur={onBlurZipCode}
    />
  );
};

ZipCodeField.propTypes = {
  isZipCodeRequired: PropTypes.bool,
  autoCompleteOnZipCode: PropTypes.bool
};

export default ZipCodeField;
